import moment from "moment";

// publishNotes response -> warning text when pay for the note's month was already sent.
// e.g. { paySentMonths: ['09-2026'] } -> "Pay for September 2026 is already complete. ..."
export const paySentWarning = (res) => {
    const months = res?.paySentMonths || [];

    if (!months.length) {
        return '';
    }

    const labels = months.map(m => moment(m, 'MM-YYYY').format('MMMM YYYY')).join(', ');

    return `\n\nPay for ${labels} is already complete. This note will not be in that pay. Provider support has been notified.`;
};
